import { eventHub } from './vuex/eventHub';

export const EventHubPlugin = {
  install(Vue) {
    Vue.prototype.$eventHub = eventHub;
  }
};
